import { createAction, props } from '@ngrx/store';

const agentIsCreated = 'AGENT_IS_CREATED';
const removeRecentAgent = 'REMOVE_RECENT_AGENT';
export const agentIsCreatedAction = createAction(
  agentIsCreated,
  props<{ newAgent: any }>()
);

export const removeRecentAgentAction = createAction(removeRecentAgent);
